module.exports = __webpack_public_path__ + "static/media/coins.92f8bee7.svg";